import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../getting-started/HelpCategoryPage.css';

/**
 * Send (P2P) Article Page
 */
const SendP2P = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Send (P2P)</h1>
                <p className="article-subtitle">
                  Learn how to instantly send USDC to friends, contacts, or your own linked accounts directly from the app.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Overview</h2>
                  <p className="article-section-intro">
                    Whether you are reimbursing a friend for dinner or moving funds to your personal crypto card, WeSplit makes 1:1 transfers fast and simple. You can initiate a payment from the main dashboard or directly from a user's profile.
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Method 1: From the Dashboard</h2>
                  <p className="article-section-intro">
                    The standard way to send money to anyone.
                  </p>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Tap Send:</strong> Click on the 'Send' button (usually represented by a minus or arrow icon) on your main dashboard or Wallets page.
                    </li>
                    <li>
                      <strong>Select Recipient:</strong>
                      <ul className="article-list-dots">
                        <li>Choose a friend from your contact list.</li>
                        <li>Or select one of your Linked Cards/Wallets if you are transferring to yourself.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Enter Amount:</strong> Input the amount of USDC you wish to send.
                    </li>
                    <li>
                      <strong>Add a Message (Optional):</strong> Attach a note, emoji, or GIF to give context to the payment.
                    </li>
                    <li>
                      <strong>Confirm:</strong> Review the details and swipe/tap to send.
                    </li>
                  </ol>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Method 2: From a Profile Page</h2>
                  <p className="article-section-intro">
                    If you are already looking at a friend's profile, you can pay them without navigating back to the home screen.
                  </p>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Visit Profile:</strong> Tap on a user's name from your contact list or a group.
                    </li>
                    <li>
                      <strong>Quick Action:</strong> Tap the 'Send' shortcut button located on their profile.
                    </li>
                    <li>
                      <strong>Enter Details:</strong> Input the amount and an optional message.
                    </li>
                    <li>
                      <strong>Confirm:</strong> Complete the transaction instantly.
                    </li>
                  </ol>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Good to Know</h2>
                </div>

                <div className="article-subsection">
                  <ul className="article-list-dots">
                    <li>
                      <strong>Flexible Flow:</strong> If you selected the wrong person by mistake, you can easily change the recipient during the process without starting over.
                    </li>
                    <li>
                      <strong>Self-Transfers:</strong> You can use the 'Send' feature to fund your linked debit cards or external hardware wallets. Simply select them from your recipient list.
                    </li>
                  </ul>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Badge Community',
                  route: getHelpRoute(getHelpArticleRoute('features', 'badge-community'))
                }}
                next={{
                  title: 'Request (P2P)',
                  route: getHelpRoute(getHelpArticleRoute('features', 'request-p2p'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default SendP2P;
